module.exports = __webpack_public_path__ + "static/media/metro-bank.e65ab02b.svg";